module.exports = __webpack_public_path__ + "media/images/television-c7280e43.png";